let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useTheme } from 'foundations-theming/utils';
import { KNOWN_THIN_BODY_FONTS, MODIFIED_BODY_FONT_WEIGHT } from '../utils/registry';
import { useBrandSettings } from '../context/PortalDataContext';

// Some nested foundations-components (e.g. the date picker's day cells and
// weekday headers) style text with raw styled-components that omit `fontFamily`,
// so they don't pick up the brand font and fall back to the default. Set the
// brand body font as the document base font so that inherited text uses it.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalFontOverrides = createGlobalStyle(_t || (_t = _`
  body {
    font-family: ${0} !important;
    ${0}
  }
`), ({
  $bodyFontFamily
}) => $bodyFontFamily, ({
  $bodyFontWeight
}) => $bodyFontWeight ? `font-weight: ${$bodyFontWeight} !important;` : '');
export const GlobalFontStyles = () => {
  var _theme$typography$bod, _brandSettings$bodyFo;
  const theme = useTheme();
  const brandSettings = useBrandSettings();
  // All body tokens are set to the same font family, so body-200 is just a
  // representative choice here — nothing special about it.
  const bodyFontFamily = (_theme$typography$bod = theme.typography['body-200']) === null || _theme$typography$bod === void 0 ? void 0 : _theme$typography$bod.fontFamily;
  if (!bodyFontFamily) return null;
  const bodyFontName = brandSettings === null || brandSettings === void 0 || (_brandSettings$bodyFo = brandSettings.bodyFont) === null || _brandSettings$bodyFo === void 0 ? void 0 : _brandSettings$bodyFo.font;
  const bodyFontWeight = bodyFontName && KNOWN_THIN_BODY_FONTS.has(bodyFontName) ? String(MODIFIED_BODY_FONT_WEIGHT) : undefined;
  return /*#__PURE__*/_jsx(StyledGlobalFontOverrides, {
    $bodyFontFamily: bodyFontFamily,
    $bodyFontWeight: bodyFontWeight
  });
};